import Container from './Container.jsx'
import trainings from '../img/trainings.jpg'
import './Trainings.css'
const Trainings = () => {
    return <div>
        <Container>
            <h1>Edzéseink helyszíne:</h1>
            <h1>-</h1>
            <h2>2400 Dunaújváros,
                Apáczai út 13.</h2>
            <h1>-</h1>
            <h2>DSZC Dunaferr
                földszinti küzdőterem</h2><br/>
             <img src={trainings} alt="logo" width={400} height={300} className='desktop' />
            <div className='image-container mobile'>
                <img src={trainings} alt="logo" />
            </div>
        </Container>
    </div>;
};

export default Trainings;